import { z } from "zod";

export const TokensResponseSchema = z.object({
  recovery_key: z.string().nullish(),
  access_token: z.string().nullish(),
  refresh_token: z.string().nullish(),
});

export type TokensResponse = z.infer<typeof TokensResponseSchema>;
